<template>
  <table id="certified_list_table" class="table table-bordered">
    <thead>
    <tr>
      <th v-for="(item, index) in headList" :key="'crt_table_header_' + index">{{item}}</th>
    </tr>
    </thead>
    <tbody>
    <tr v-for="(item, index) in memberList" :key="'crt_table_tr_' + index" >
      <td><a :href="memberSrc(item.id)" target="_blank">{{item.certNumber}}</a></td>
      <td><a :href="memberSrc(item.id)" target="_blank">{{item.name}}</a></td>
      <td><a :href="memberSrc(item.id)" target="_blank">{{item.level}}</a></td>
      <td><a :href="memberSrc(item.id)" target="_blank">{{item.issueDate}}</a></td>
    </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: "CertifiedList",
  components: {},
  props: {},
  data () {
    return {
      title: '持证裁判员/持证教练员',
      memberList: [
        {
          certNumber: 'SHBA20210001',
          name: '曹建',
          level: 'E级',
          issueDate: '2019-1-1',
          id: 'shl-001',
        },
        {
          certNumber: 'SHBA20210001',
          name: '曹建',
          level: 'E级',
          issueDate: '2019-1-1',
          id: 'shl-001',
        },
        {
          certNumber: 'SHBA20210001',
          name: '曹建',
          level: 'E级',
          issueDate: '2019-1-1',
          id: 'shl-001',
        },
        {
          certNumber: 'SHBA20210001',
          name: '曹建',
          level: 'E级',
          issueDate: '2019-1-1',
          id: 'shl-001',
        },
        {
          certNumber: 'SHBA20210001',
          name: '曹建',
          level: 'E级',
          issueDate: '2019-1-1',
          id: 'shl-001',
        },
        {
          certNumber: 'SHBA20210001',
          name: '曹建',
          level: 'E级',
          issueDate: '2019-1-1',
          id: 'shl-001',
        },
        {
          certNumber: 'SHBA20210001',
          name: '曹建',
          level: 'E级',
          issueDate: '2019-1-1',
          id: 'shl-001',
        },
        {
          certNumber: 'SHBA20210001',
          name: '曹建',
          level: 'E级',
          issueDate: '2019-1-1',
          id: 'shl-001',
        },
        {
          certNumber: 'SHBA20210001',
          name: '曹建',
          level: 'E级',
          issueDate: '2019-1-1',
          id: 'shl-001',
        },
        {
          certNumber: 'SHBA20210001',
          name: '曹建',
          level: 'E级',
          issueDate: '2019-1-1',
          id: 'shl-001',
        },
      ],
      headList: [
        '证书编号',
        '姓名',
        '级别',
        '证书颁发日期',
      ]
    }
  },
  methods: {
    memberSrc(productId) {
      return this.$route.path + '/user/' + productId;
    },
  }
}
</script>

<style scoped>

  #certified_list_table {
    width: 100%;
  }
  #certified_list_table thead tr {
    background-color: #f6f6f6;
  }

  #certified_list_table thead th {
    color: #333;
    font-size: 1.3rem;
    font-weight: bold;
    text-align: center;
  }

  #certified_list_table tbody td {
    text-align: center;
  }

  #certified_list_table tbody td > a {
    color: #333;
    font-size: 1.3rem;
    text-decoration: none;
  }

  #certified_list_table tbody td > a:hover {
    color: #fc1a34;
  }

</style>



// WEBPACK FOOTER //
// src/components/train/CertifiedList.vue